import { chakra, Text } from '@chakra-ui/react';

export const Label = chakra(Text, {
  baseStyle: {
    fontSize: '14px',
    mr: 8,
  },
});
